import React, { useState } from "react";
import axios from "axios";
import "./Verify.css"; // ✅ use verify email styles

import { API_BASE } from "../utils/apiConfig";

export default function ResetPassword({ onAuth }) {
  const token = new URLSearchParams(window.location.search).get("token");

  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isStrongPassword = (p) =>
    p.length >= 8 && /\d/.test(p) && /[A-Za-z]/.test(p);

  const reset = async () => {
    if (!token) {
      setError("Invalid or missing reset link.");
      return;
    }

    if (!isStrongPassword(password)) {
      setError(
        "Password must be at least 8 characters and include both letters and numbers."
      );
      return;
    }

    setLoading(true);
    setError("");

    try {
      await axios.post(`${API_BASE}/auth/reset-password`, {
        token,
        password
      });

      setDone(true);
    } catch (err) {
      if (err.response?.data?.error === "INVALID_TOKEN") {
        setError("This reset link is invalid or already used.");
      } else if (err.response?.data?.error === "WEAK_PASSWORD") {
        setError("Password does not meet security requirements.");
      } else {
        setError("Password reset failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-page">
      <div className="verify-card">
        {!done ? (
          <>
            <h2>Set new password</h2>
            <p className="verify-subtitle">
              Choose a strong password to secure your account.
            </p>

            <div className="verify-input">
              <input
                type="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
            </div>

            {error && <p className="verify-error">{error}</p>}

            <button
              className="verify-btn"
              onClick={reset}
              disabled={loading}
            >
              {loading ? "Updating…" : "Update password"}
            </button>
          </>
        ) : (
          <>
            <h2>Password updated</h2>
            <p className="verify-subtitle">
              Your password has been updated successfully.
            </p>

            <button
              className="verify-btn"
              onClick={() => onAuth("login")}
            >
              Go to login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
